// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
const AdvancedSearchConfig: any = function () {
   return function (config: any): any {
      const values = config.advanced_search
      const hasCustomSearchRows = values.custom_search_rows.length
      const rowsValues = hasCustomSearchRows ? values.custom_search_rows : ['AND,', 'AND,', 'AND,']
      const customSearchRows = rowsValues.map(function (customSearchRow: any, idx: any) {
         const [boolHandler, key] = (hasCustomSearchRows ? customSearchRow : 'AND,').split(',')

         // Result object
         return {
            key: key ?? '',
            value: '',
            boolean: boolHandler ?? 'AND',
            queryModifier: '',
            minLength: 0,
            id: idx
         }
      })

      // Database is opt-in: it is only offered in the scope builder when it is enabled in the Advanced Search facets
      const databaseFacetInAdvancedSearch = (values.facets || []).some((f: any) => f.name === 'databaseName')
      const allFacets = [
         {
            name: "contentType",
            label: "Content Type"
         },
         {
            name: "discipline",
            label: "Discipline"
         },
         {
            name: "language",
            label: "Language"
         },
         {
            name: "library",
            label: "Library Location"
         },
         {
            name: "newRecords",
            label: "New Records"
         },
         ...(databaseFacetInAdvancedSearch ? [{ name: "databaseName", label: "Database" }] : [])
      ]

      const scopeBuilderSearchFields = [
         {
            label: "ISSN",
            key: "IssnAll"
         }
      ]
    
      const scopeBuilderSearchRows = [{
         key: "IssnAll",
         value: '',
         boolean: 'AND',
         queryModifier: '',
         minLength: 0,
         id: 0
      }]


      // Result
      return {
         enabled: values.enabled,
         searchButtonAboveForm: values.search_button_above_form,

         // custom search fields, configures:
         // - the search fields dropdown ("anywhere, title, author, subject" etc...)
         // - the queryModifier ("AllWords", "AnyWords", "ExactMatch", "BeginsWith")
         // - the available BOOL operators
         // Always create full object (fields, modifiers, booleans), there are no checks on object keys
         // if array is empty, defaults are shown. Otherwise array needs to be filled with the values to display (will be localized later)
         customSearchRows,
         // Compound a key object based on configuration to perform usage
         customSearchFields: values.custom_search_fields.map((customSearchField: any) => ({
            key: customSearchField.key,
            label: customSearchField.label || customSearchField.key
         })),
         scopeBuilderSearchFields,
         scopeBuilderSearchRows,
         maxCustomFields: 20,
         maxSearchScopeFields: 10,
         filters: {
            contentType: values.content_type_filter || [],
            discipline: values.discipline_filter || [],
            language: values.content_type_filter || []
         },
         // datePicker
         datePicker: {
            enabled: values.direct_date_entry
         },

         // for refine pane 
         refinePane: {
            enabled: values.refine_in_options,
            refineList: values.refine_in_options_list,
            intstitutionName: config.info.institutionName
         },

         facets: {
            enabled: values.enable_facets,
            facetsList: values.facets,
            allFacets
         }
      }
   }
}

angular.module('summonApp.factories.configs')
   .factory('advancedSearchConfig', AdvancedSearchConfig)

module.exports = AdvancedSearchConfig
